<template>
    <div>
        <div class="tabs  pt-8 mb-2">
            <button class="flex-1" v-for="(tab, index) in tabs" :key="index"  :class=" { active: selectedIndex === index }"
                @click="selectTab(index)">
                {{ tab.name }}
            </button>
             <button class="flex-1">
                <div ></div>
            </button>
        </div>
        <!-- <hr /> -->
        <div class="tab-content">
            <component :is="selectedComponent"></component>
        </div>
    </div>
</template>
  
  <script>
 import Business from './modules/bus/Business.vue';
 import BeneficialOwners from './modules/bo/BeneficialOwners.vue';
 import DocumentSummary from './modules/ds/DocumentSummary.vue';
 import TermsOfService from './modules/tos/TermsOfService.vue';


  export default {
    components: {
        Business,
        BeneficialOwners,
        DocumentSummary,
        TermsOfService,
    },
    data() {
        return {
            selectedIndex: 0,
            tabs: [
                { name: 'Business', component: Business },
                { name: 'Beneficial Owners', component: BeneficialOwners },
                { name: 'Document Summary', component: DocumentSummary },
                { name: 'Terms of Service', component: TermsOfService },
            ],
        };
    },

    computed: {
        selectedComponent() {
            return this.tabs[this.selectedIndex].component;
        },
    },

    methods: {
        selectTab(index) {
            this.selectedIndex = index;
        },
    },

  };
  </script>
  
  <style scoped>
  .tabs {
    display: flex;
  }
  .tabs button {
    padding: 0.5rem 1.5rem;
  font-size: 0.9rem;
  color: #7A90A7;
  font-size: 14px;
    
    font-weight: 600;
    background: transparent;
    outline: none;
    cursor: pointer;
    border: none;
    border-bottom: 2px solid #F0F4FE;
  }
  .tabs .active {
    font-weight: bold;
    color: #14171F;
    background: white;
    border-bottom: 2px solid #FCC210;
  }


  </style>